import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- Google Analytics 4 ---
const GA_MEASUREMENT_ID = 'G-933PG8REC8';
function initGA() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  // Avoid injecting the GA script more than once
  if (document.getElementById('ga4-gtag-script')) return;
  // Load the official gtag.js library into the <head>
  const script = document.createElement('script');
  script.id = 'ga4-gtag-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  function gtag(...args: any[]) {
    w.dataLayer.push(args);
  }
  w.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: true
  });
  // Explicit page_view so the initial load is always recorded
  gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search
  });
}
initGA();
render(<App data-id="element-94" data-mp="15lu3ialzy091" />, document.getElementById('root'));